import React from "react";
import { RiPanelCheckListTransLateHelper } from "../../../../../Utils/TranslateHelper";
import SectorWeightingGraph from "./SectorWeightingGraph.jsx";
import { useSelector } from "react-redux";

const RiPanelAllocationInfo = () => {
  const state = useSelector((state) => state.RelatedInfoPanelReducers.RiPanelAllocationInfo);
  return (
    <div className="allocationInfo">
      {state.loading ? (
        <div className="news-message large-normal">
          <p>{state.loadingMessage}</p>
        </div>
      ) : !state.isNoDataAvailable && state.sectorWgtList?.length > 0 ? (
        <div className="allocation-content">
          <div className="allocation-title">
            {RiPanelCheckListTransLateHelper.ALLOCATIONS_SECTOR_WEIGHTINGS}
          </div>
          <SectorWeightingGraph />
        </div>
      ) : (
        <div className="news-message large-normal">
          <p>{state.errorMessage || "Data not available"}</p>
        </div>
      )}
    </div>
  );
};

export default RiPanelAllocationInfo;